import { create } from 'zustand';
import { IContact } from '../interfaces/IContact';

interface ContactStore {
  contacts: IContact[];
  loading: boolean;
  error: string | null;
  setContacts: (contacts: IContact[]) => void;
  addContact: (contact: IContact) => void;
  updateContact: (id: string, contact: IContact) => void;
  removeContact: (id: string) => void;
  setLoading: (loading: boolean) => void;
  setError: (error: string | null) => void;
}

export const useContactStore = create<ContactStore>((set) => ({
  contacts: [],
  loading: false,
  error: null,

  setContacts: (contacts) => set({ contacts }),
  
  addContact: (contact) =>
    set((state) => ({
      contacts: [...state.contacts, contact],
    })),

  updateContact: (id, contact) =>
    set((state) => ({
      contacts: state.contacts.map((c) => (c.id === id ? contact : c)),
    })),

  removeContact: (id) =>
    set((state) => ({
      contacts: state.contacts.filter((c) => c.id !== id),
    })),

  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
}));
